var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.1111C3 10.8255 3.12215 10.5535 3.33564 10.3637L11.3356 3.25259C11.7145 2.9158 12.2855 2.9158 12.6644 3.25259L20.6644 10.3637C20.8779 10.5535 21 10.8255 21 11.1111V20.4352C21 20.9875 20.5523 21.4352 20 21.4352L15.2222 21.4352L15.2222 19.1019C15.2222 17.3223 13.7796 15.8796 12 15.8796C10.2204 15.8796 8.77778 17.3223 8.77778 19.1019L8.77778 21.4352L4 21.4352C3.44772 21.4352 3 20.9875 3 20.4352V11.1111Z",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a34cc9bd30e3d037d545c762a66800e1.svg";
export { ForwardRef as ReactComponent };